export function useIsRender(cb: () => boolean, active?: () => void): Readonly<globalThis.Ref<boolean, boolean>> {
  const r = shallowRef(cb())
  const off = watch(
    () => cb(),
    (i) => {
      if (!i) return
      r.value = true

      nextTick(() => {
        active?.()
        off()
      })
    },
    { immediate: true }
  )
  return toRef(() => r.value)
}
